define('lib/fileuploader/avatar',['require','underscore','jquery','lib/fileuploader/base','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.Event.UI','signals'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var FileUploaderBase = require('lib/fileuploader/base');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var podioEventUI = require('lib/Podio.Event.UI');
  var signalsLib = require('signals');

  var defaultOptions = {
    multipleFiles: false,
    onlyAllowImages: true,
    showDragDropTip : false
  };

  var options;

  var signals = {
    onAvatarRemoved: new signalsLib.Signal()
  };

  function render(elmTarget, _options) {
    options = _options ? _.defaults(_options, defaultOptions) : defaultOptions;

    options.elmListContainer = options.elmListContainer || options.elmAvatarWrapper;
    options.elmDropContainer = options.elmDropContainer || options.elmAvatarWrapper;
    options.elmRemoveAttachment = $(options.removeAttachmentPath);

    var uploader = new FileUploaderBase(elmTarget, options);

    uploader.signals.onFileAdded.add(onAvatarUploading);
    uploader.signals.onFileUploaded.add(onAvatarUploaded);
    uploader.init();

    podioEventUI.bind('click', options.removeAttachmentPath, onRemoveAttachmentClick);

    return uploader;
  }

  function onAvatarUploading() {
    options.elmAvatarWrapper.find('img').hide();
    options.elmSubmitButton.attr('disabled', true);
  }

  function onAvatarUploaded(file) {
    options.elmRemoveAttachment.addClass('active');
    options.elmAvatarUpload.find('input[type=hidden]').val(file.fileId);
    options.elmSubmitButton.removeAttr('disabled');

    transport.getJSON(routes.url_file_path(file.fileId), {
      requestData: {
        'size' : 'large'
      }
    }, function(responseData) {
        options.elmAvatarWrapper.find('img').attr('src', responseData.data.file.link + '/large');
        options.elmAvatarWrapper.find('img').show();
    });
  }

  function onRemoveAttachmentClick(elmTarget, e) {
    var fileId = options.elmContactAvatarInput.val();
    var newFileId = options.elmUploadImage.data('original-avatar-id');

    if(fileId == options.elmUploadImage.data('original-avatar-id')) {
      options.currentAvatarUrl = options.elmUploadImage.data('default-avatar-url');
      newFileId = '';
    }

    options.elmRemoveAttachment.removeClass('active');
    options.elmUploadImage.attr('src', options.currentAvatarUrl);
    options.elmContactAvatarInput.val(newFileId);

    signals.onAvatarRemoved.dispatch();
  }

  return {
    render: render,
    signals: signals
  };

});


